import React, { useContext, useEffect, useState } from 'react'
import { initialTokenList, TokenContext } from '../../constant/constant';
import { useAccount } from 'wagmi';
import { convertBigToSmallDigitWithSpecificDecimal, getTokenBalance } from '../../utils/commonFunction';
import { chevronDownIcon } from '../../constant/icon';
import Loader from '../loader/Loader';

const Token = ({ handleSelectToken, token }) => {

    const { tokenList, setTokenList } = useContext(TokenContext);
    const [isOpenFromDropdown, setIsOpenFromDropdown] = useState(false);

    const { address: walletAddress } = useAccount()

    const toggleFirstDropdown = () => {
        setIsOpenFromDropdown(!isOpenFromDropdown);
    };

    const handleTokenSelect = (item) => {
        handleSelectToken(item)
        setIsOpenFromDropdown(false);
    }


    const fetchTokenBalances = async () => {
        const updatedTokenList = await Promise.all(
            initialTokenList.map(async (token) => {
                try {
                    const balance = await getTokenBalance(token.address, walletAddress);
                    return { ...token, balance };
                } catch (error) {
                    console.error(`Error fetching balance for ${token.symbol}:`, error);
                    return { ...token, balance: '0' }; // Default to 0 if there's an error
                }
            })
        );
        setTokenList(updatedTokenList);
    };

    useEffect(() => {
        fetchTokenBalances();
        // eslint-disable-next-line
    }, [initialTokenList, walletAddress, token]);


    return (
        <div className="relative">
            <div
                onClick={toggleFirstDropdown}
                className="flex cursor-pointer items-center justify-between gap-5 rounded-xl border border-zinc-200 bg-white p-2.5 text-zinc-900 transition-colors hover:border-zinc-300 focus:ring-2 focus:ring-teal-500/30 dark:border-zinc-700 dark:bg-zinc-900/90 dark:text-zinc-100 dark:hover:border-zinc-600"
            >
                {token.name ? (
                    <div className="flex items-center justify-between w-full">
                        <div className="flex">
                            <img src={token.logoURI} alt={token.name} className="me-2 h-6 w-6 rounded-full bg-zinc-100 object-cover dark:bg-zinc-800" />
                            <span>{token.symbol}</span>
                        </div>
                        <i className={chevronDownIcon}></i>
                    </div>
                ) : (
                    <div className="flex justify-between w-full">
                        <span className="text-zinc-500 dark:text-zinc-400">Select Token</span>
                        <i className={chevronDownIcon}></i>
                    </div>
                )}
            </div>
            {isOpenFromDropdown && (
                <ul className="absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-xl border border-zinc-200 bg-white py-2 shadow-xl dark:border-zinc-700 dark:bg-zinc-950">
                    {tokenList.map((item) => (
                        <li
                            key={item.address}
                            onClick={() => handleTokenSelect(item)}
                            className="flex cursor-pointer items-center px-3 py-2.5 text-zinc-800 transition-colors hover:bg-zinc-100 dark:text-zinc-200 dark:hover:bg-zinc-800/80"
                        >
                            <div className="flex justify-between items-center w-full">
                                <div className="flex">
                                    <img src={item.logoURI} alt={item.name} className="w-7 h-7 rounded-full object-cover me-2" />
                                    <span>{item.symbol}</span>
                                </div>
                                <span className="text-sm text-zinc-500 dark:text-zinc-400">{convertBigToSmallDigitWithSpecificDecimal(item.balance, item.decimals) ?? <Loader size="15px" stroke="#0d9488" />}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default Token